import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ category }) => {
  return (
    <Link to={`/categories/${category.id}`} className="group">
      <div className="relative overflow-hidden bg-gray-800 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
        {/* Image Container */}
        <div className="relative aspect-square overflow-hidden">
          <img
            src={category.last_product_photo || category.image_url || 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=600&h=600&fit=crop&crop=center'}
            alt={category.name_fr}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            onError={(e) => {
              e.target.src = 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=600&h=600&fit=crop&crop=center';
            }}
          />
          
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          
          {/* Category Info */}
          <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
            <h3 className="text-xl font-bold mb-2 group-hover:text-yellow-500 transition-colors">
              {category.name_fr}
            </h3>
            <p className="text-gray-300 text-sm mb-3 line-clamp-2">
              {category.description_fr}
            </p>
            <div className="flex items-center justify-between">
              <span className="text-yellow-500 font-semibold">
                {category.product_count} produits
              </span>
              <span className="text-white/80 text-sm">
                Découvrir →
              </span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard; 